export default __webpack_public_path__ + "static/media/slt2-min.d3f1dcc4.jpg";